<template>
  <div class="container">
    <div class="flex flex-row-left  margin-top-20 ">
      <div class="flex-item-center">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="订单号相关">
            <el-input style="width:200px" v-model="formInline.platformName" placeholder="马帮订单或交易号" clearable />
          </el-form-item>
          <el-form-item label="收件人邮箱">
            <el-input style="width:200px" v-model="formInline.email" placeholder="收件人邮箱" clearable />
          </el-form-item>
          <el-form-item label="发送状态">
            <el-select
                @clear="formInline.isSend=''"
                style="width:200px"
                v-model="formInline.isSend"
                clearable
                placeholder="请选择发送状态"
            >
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
<!--      <div>-->
<!--        <el-button type="danger" @click="openEidt" >手动发送</el-button>-->
<!--      </div>-->
    </div>
    <div class="margin-20-0">
      <div>
        <el-table
            :max-height="dynamicHeight"
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="default"
        >
          <el-table-column
              label="触发方式"
              width="100"
              prop="fromType"
          ></el-table-column>
          <el-table-column
              label="马帮订单号"
              min-width="150"
              prop="fromTypeId"
          ></el-table-column>
          <el-table-column
              label="交易号"
              min-width="100"
              prop="salesRecordNumber"
          ></el-table-column>
          <el-table-column
              label="收件邮箱"
              min-width="150"
              prop="email"
          ></el-table-column>
          <el-table-column
              label="发送参数"
              min-width="200"
              prop="sendArgs"
          >
            <template #default="scope">
              <div>客户名称：{{scope.row.sendArgs?.name}}</div>
              <div>产品名称：{{scope.row.sendArgs?.productName}}</div>
              <div>物流渠道：{{scope.row.sendArgs?.trackChannel}}</div>
              <div>物流单号：{{scope.row.sendArgs?.trackNumber}}</div>
            </template>
          </el-table-column>
          <el-table-column
              label="重试次数"
              min-width="100"
              prop="tryCount"
          ></el-table-column>
          <el-table-column
              label="失败原因"
              min-width="150"
              prop="reason"
          ></el-table-column>
          <el-table-column
              label="邮件状态"
              min-width="80"
              prop="isSend"
          >
            <template #default="scope">
              <span v-if="scope.row?.isSend==0">未发送</span>
              <span v-else> 已发送 </span>
            </template>
          </el-table-column>
          <el-table-column
              label="订单状态快照"
              min-width="80"
              prop="orderStatus"
          >
            <template #default="scope">
              <span v-if="scope.row?.orderStatus==2">配货中</span>
              <span v-if="scope.row?.orderStatus==3">已发货</span>
              <span v-if="scope.row?.orderStatus==4">已完成</span>
              <span v-if="scope.row?.orderStatus==5">已作废</span>
            </template>
          </el-table-column>
          <el-table-column
              label="录入时间"
              min-width="120"
              prop="CreateTime"
          ></el-table-column>
          <el-table-column
              label="发送时间"
              min-width="120"
              prop="UpdateTime"
          ></el-table-column>
          <el-table-column
              label="操作"
              min-width="100"
              prop="addServices"
          >
            <template #default="scope">
              <el-button :disabled="scope.row.isSend" link type="primary" size="small" @click="openEidt(scope.row)">手动发送</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
      <reSendEmail ref="reSendEmail" @close="close"></reSendEmail>
    </div>
  </div>
</template>
<script>
import {ElButton, ElForm, ElFormItem, ElInput, ElPagination, ElTable, ElTableColumn,ElSelect,ElOption} from "element-plus";
import reSendEmail from "@/components/resendEmail.vue";
import {resendEmail} from "@/utils/api";
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";
export default {
  name: "orderResendEmail",
  components: {
    ElForm,ElFormItem,ElButton,ElInput,ElTable,
    ElTableColumn,ElPagination,ElSelect,ElOption,reSendEmail
  },
  mixins:[DynamicHeightMixin],
  data(){
    return{
      currentPage:1,
      pageSize:20,
      pageTotal:0,
      formInline:{},
      tableData:[],
      options:[
        {
          value: 1,
          label: '已发送',
        },
        {
          value: 0,
          label: '未发送',
        },
      ]
    }
  },
  beforeMount() {
    this.getPlatform()
  },
  methods:{
    onSubmit(){
      this.PageNumber = 1
      this.getPlatform()
    },
    getPlatform(){
      resendEmail({PageNumber:this.currentPage,
        PageSize:this.pageSize,...this.formInline}).then(res => {
        console.log(res)
        this.tableData = res.Data
        this.pageTotal = res.Total
      }).catch(err=>{
        console.log(err)
      })
    },
    openEidt(data){
      this.$refs.reSendEmail.open(data)
    },
    close(){
      this.getPlatform()
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getPlatform();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getPlatform();
    },
  }
}
</script>
<style scoped>
.container{
  width: 92%;
  margin:0 auto;
}
::v-deep .container .el-form-item{
  margin-bottom:0!important;
}
</style>